import * as t from "./types";
import { createReducer } from "../../util";

const initState = {
    details: {},
    error: null,
    loading: false
};

const getAddressCityStateZip = (location, prefix = "") => {
    if (location[`${prefix}city`] && location[`${prefix}statecode`] && location[`${prefix}zipcode`]) {
        var address = `${location[`${prefix}city`]}`
        // Don't add state and zip if the state is '* Coming Soon *'
        if (location[`${prefix}statecode`].toUpperCase() !== 'CS') {
            address += `, ${location[`${prefix}statecode`].toUpperCase()} ${location[`${prefix}zipcode`]}`
        }
        return address;
    }
}

const capitalize = string => string.charAt(0).toUpperCase() + string.slice(1);

const getBranchPhoneTypeName = branchPhone =>
    branchPhone.phonetype === "tollFree"
        ? "Toll Free"
        : capitalize(branchPhone.phonetype);

const getNormalizedPhoneNumber = phoneNumber => phoneNumber.replace(/\D/g, "");

const getFormattedPhoneNumber = phoneNumber =>
    getNormalizedPhoneNumber(phoneNumber).replace(
        /(\d{3})(\d{3})(\d{4})/,
        "$1-$2-$3"
    );

const getManager = (branchEmployees, role) => {
    const filtered =
        branchEmployees &&
        branchEmployees.filter(
            branchEmployee =>
                branchEmployee.role === role &&
                !!branchEmployee.userInfo
        );
    if (filtered.length) {
        return filtered[0];
    }
};

/** in other words, get sales reps */
const getNonManagerEmployees = branchEmployees =>
    branchEmployees &&
    branchEmployees
        .filter(
            branchEmployee =>
                branchEmployee.role !== "branch-manager" &&
                branchEmployee.role !== "regional-manager" &&
                !!branchEmployee.userInfo
        )
        /**
         * the func arg of sort returns:
         * less than 0 - a comes before b
         * greater than 0 - b comes before a
         * equal to 0 - a and b are left unchanged with respect to each other
         */
        .sort(
            (branchEmployeeA, branchEmployeeB) =>
                Number(branchEmployeeA.userInfo.phoneExtension) -
                Number(branchEmployeeB.userInfo.phoneExtension)
        );

const getDetailsFromPayload = payload => {
    const details =
        Array.isArray(payload) && payload.length === 1 ? payload[0] : payload;

    const sortOrder = {
        tollFree: 1,
        local: 2,
        fax: 3
    };

    return {
        ...details,
        branchPhones:
            details.branchPhones &&
            details.branchPhones
                .map(branchPhone => ({
                    ...branchPhone,
                    normalizedPhoneNumber: getNormalizedPhoneNumber(
                        branchPhone.branchphonenumber
                    ),
                    formattedPhoneNumber: getFormattedPhoneNumber(
                        branchPhone.branchphonenumber
                    ),
                    branchPhoneTypeName: getBranchPhoneTypeName(branchPhone)
                }))
                .sort(
                    (a, b) => sortOrder[a.phonetype] - sortOrder[b.phonetype]
                ),
        addressCityStateZip: getAddressCityStateZip(details),
        mailingAddressCityStateZip: getAddressCityStateZip(details, "mailing"),
        branchManager: getManager(details.branchEmployees, "branch-manager"),
        regionalManager: getManager(details.branchEmployees, "regional-manager"),
        nonManagerEmployees: getNonManagerEmployees(details.branchEmployees)
    };
};

/* process the data returned from the http API
 NOTE: this reducer runs against a "synthetic" action, with a 
 suffix of "_COMPLETED" added to the original action type. This
 action is created by the api middleware in response to the original
 action and the payload contains the returned JSON
 */

const resetState = state => ({
    ...state,
    showingAll: false,
    error: null,
    jumpToCurrentLocationError: null,
    details: {}
});
const locationDetailsReducer = createReducer(initState)({
    [t.LOAD_LOCATION + "_STARTED"]: (state, action) => ({
        ...resetState(state),
        error: null,
        loading: true
    }),
    [t.LOAD_LOCATION + "_FAILED"]: (state, action) => ({
        ...state,
        error: action.payload,
        loading: false
    }),
    [t.LOAD_LOCATION + "_COMPLETED"]: (state, action) => ({
        ...resetState(state),
        loading: false,
        error: null,
        details: getDetailsFromPayload(action.payload)
    }),

    [t.JUMP_TO_CURRENT_LOCATION + "_FAILED"]: (state, action) => ({
        ...state,
        jumpToCurrentLocationError: action.payload
    })
});

export default locationDetailsReducer;



// WEBPACK FOOTER //
// ./ducks/location-details/reducers.js